function shopify_order_history_page_type() {
  var pathname = window.location.pathname.replace(/\/+$/, ""); // drop trailing /
  var parts = pathname.split("/");
  var lastSegment = parts[parts.length - 1];
  var result = { page_type: "", order_number: null };

  if (lastSegment === "list") {
    result.page_type = "list";
  } else if (lastSegment === "reorder") {
    result.page_type = "reorder";
  } else if (!isNaN(lastSegment)) {
    result.page_type = "order_detail";
    result.order_number = lastSegment;
  } else {
    result.page_type = "unknown";
  }

  return result;
}

function shopify_email_hash_refresh() {
  $.ajax({
    type: "POST",
    url: window.ss_order_history_config.remote_url,
    dataType: "json",
    data: {
      using_json: "true",
      do: "shopify_email_hash_refresh",
      permanent_domain: window.ss_order_history_config.permanent_domain,
      email: window.ss_order_history_config.email
    }
  }).done(function (data) {
    if (data.status == 1) {
      location.reload();
    } else {
      var msg = "<strong>Error:</strong><br>";
      if (data.errors && data.errors.length) msg += data.errors.join("<br>");
      $("ss-order-history").html(msg);
    }
  });
}

function shopify_order_history_list() {
  $.ajax({
    type: "POST",
    url: window.ss_order_history_config.remote_url,
    dataType: "json",
    data: {
      using_json: "true",
      do: "shopify_order_history_list",
      permanent_domain: window.ss_order_history_config.permanent_domain,
      email: window.ss_order_history_config.email,
      hash: window.ss_order_history_config.hash
    }
  }).done(function (data) {
    if (data.status == 1) {
      var template = Handlebars.compile($("#ss_order_history_list_template").html());
      var output = template(data);
      $("ss-order-history").html(output);
    } else {
      var msg = "<strong>Error:</strong><br>";
      if (data.errors && data.errors.length) msg += data.errors.join("<br>");
      $("ss-order-history").html(msg);
    }
  });
}

function shopify_order_history_detail(order_number) {
  $.ajax({
    type: "POST",
    url: window.ss_order_history_config.remote_url,
    dataType: "json",
    data: {
      using_json: "true",
      do: "shopify_order_history_detail",
      permanent_domain: window.ss_order_history_config.permanent_domain,
      email: window.ss_order_history_config.email,
      hash: window.ss_order_history_config.hash,
      order_number: order_number
    }
  }).done(function (data) {
    if (data.status == 1) {
      var template = Handlebars.compile($("#ss_order_history_detail_template").html());
      var output = template(data.order_details);
      $("ss-order-history").html(output);
      shopify_order_history_product_process(data.product_ids);
    } else {
      var msg = "<strong>Error:</strong><br>";
      if (data.errors && data.errors.length) msg += data.errors.join("<br>");
      $("ss-order-history").html(msg);
    }
  });
}

function shopify_order_history_product_process(jsonData) {
  $.each(jsonData, function (id, data) {
    $.ajax({
      url: "/products/" + data.handle + ".json",
      method: "GET"
    }).done(function (response) {
      $(".ss-order-history-product-buttons[data-product_id='" + id + "']").each(function () {
        var button_data = {};
        button_data.product_id = id;
        button_data.product = response.product;
        button_data.variant_id = $(this).data("variant_id");
        button_data.handle = $(this).data("handle");
        button_data.in_stock = $(this).data("in_stock");
        button_data.preorderable = $(this).data("preorderable");
        button_data.show_quantity = 0;

        var matchedVariant = button_data.product.variants.find(function (variant) {
          return variant.id == button_data.variant_id;
        });

        var debug_data = {
          product_id: String(id),
          product_handle: data.handle,
          requested_variant_id: String(button_data.variant_id || ""),
          historical_in_stock: button_data.in_stock,
          historical_preorderable: button_data.preorderable,
          matched_variant: Boolean(matchedVariant),
          shopify_available: matchedVariant ? matchedVariant.available : null,
          shopify_inventory_management: matchedVariant ? matchedVariant.inventory_management : null,
          shopify_inventory_policy: matchedVariant ? matchedVariant.inventory_policy : null
        };

        if (button_data.variant_id && !matchedVariant) {
          // The historical variant no longer exists. Keep only Choose options.
          button_data.variant_id = "";
        } else if (matchedVariant && matchedVariant.available === false) {
          button_data.text = "Notify me when available";
          button_data.type = "notify";
          button_data.product_json = Object.assign({}, button_data.product, {
            variants: [matchedVariant]
          });
          button_data.product_json = JSON.stringify(button_data.product_json);
        } else if (
          matchedVariant &&
          (matchedVariant.available === true || Number(button_data.in_stock) > 0 || Number(button_data.preorderable) > 0)
        ) {
          // Shopify's product JSON does not always include `available`. Prefer an
          // explicit live value, then fall back to the inventory data from the
          // order-history API when that property is omitted.
          if (!Number(button_data.in_stock) && Number(button_data.preorderable)) {
            button_data.text = "Pre-order";
            button_data.type = "pre_order";
          } else {
            button_data.text = "Add to cart";
            button_data.type = "in_stock";
          }
        } else {
          button_data.text = "Notify me when available";
          button_data.type = "notify";
          button_data.product_json = Object.assign({}, button_data.product, {
            variants: matchedVariant ? [matchedVariant] : []
          });
          button_data.product_json = JSON.stringify(button_data.product_json);
        }

        debug_data.button_text = button_data.text || "Choose options only";
        debug_data.button_type = button_data.type || "none";
        console.info("[SS Order History] Availability decision", debug_data);

        var template = Handlebars.compile($("#ss_order_history_product_buttons_template").html());
        var output = template(button_data);
        $(this).html(output);
      });
    }).fail(function (xhr) {
      console.error("[SS Order History] Product availability request failed", {
        product_id: String(id),
        product_handle: data.handle,
        status: xhr.status
      });
    });
  });
}

$(document).ready(function () {
  if (!window.ss_order_history_config) {
    $("ss-order-history").html("The app did not load correctly. Please refresh the page. If the issue persists, contact us for assistance.");
    return;
  }
  if (!window.ss_order_history_config.customer_id) {
    var template = Handlebars.compile($("#ss_order_history_log_in_template").html());
    $("ss-order-history").html(template({
      login_url: window.ss_order_history_config.login_url
    }));
    return;
  }
  if (!window.ss_order_history_config.email) {
    $("ss-order-history").html("Your customer email is missing from the settings. Please visit your account page to ensure it's correctly set.");
    return;
  }
  if (!window.ss_order_history_config.hash) {
    shopify_email_hash_refresh();
    return;
  }

  var page_type = shopify_order_history_page_type();

  if (page_type.page_type == "order_detail") {
    shopify_order_history_detail(page_type.order_number);
  } else if (page_type.page_type == "reorder") {
    $("ss-order-history").html("Reorder future page.");
  } else {
    shopify_order_history_list();
  }
});

//datetime
Handlebars.registerHelper("datetime", function (datetime, format) {
  return dayjs.unix(datetime).format(format);
});

// is
Handlebars.registerHelper("is", function (a, b) {
  var next = arguments[arguments.length - 1];
  return a == b ? next.fn(this) : next.inverse(this);
});

// is not
Handlebars.registerHelper("isnot", function (a, b) {
  var next = arguments[arguments.length - 1];
  return a != b ? next.fn(this) : next.inverse(this);
});

// equal
Handlebars.registerHelper("eq", function (a, b) {
  var next = arguments[arguments.length - 1];
  return Number(a) === Number(b) ? next.fn(this) : next.inverse(this);
});

// greater than or equal to
Handlebars.registerHelper("ge", function (a, b) {
  var next = arguments[arguments.length - 1];
  return Number(a) >= Number(b) ? next.fn(this) : next.inverse(this);
});

// greater than
Handlebars.registerHelper("gt", function (a, b) {
  var next = arguments[arguments.length - 1];
  return Number(a) > Number(b) ? next.fn(this) : next.inverse(this);
});

// less than or equal to
Handlebars.registerHelper("le", function (a, b) {
  var next = arguments[arguments.length - 1];
  return Number(a) <= Number(b) ? next.fn(this) : next.inverse(this);
});

// less than
Handlebars.registerHelper("lt", function (a, b) {
  var next = arguments[arguments.length - 1];
  return Number(a) < Number(b) ? next.fn(this) : next.inverse(this);
});

// not equal
Handlebars.registerHelper("ne", function (a, b) {
  var next = arguments[arguments.length - 1];
  return Number(a) !== Number(b) ? next.fn(this) : next.inverse(this);
});

// is Negative
Handlebars.registerHelper('isNegative', function(value, options) {
  return value.startsWith('-') ? options.fn(this) : options.inverse(this);
});
